import { render, staticRenderFns } from "./saldos_clientes.vue?vue&type=template&id=29098824&"
import script from "./saldos_clientes.vue?vue&type=script&lang=js&"
export * from "./saldos_clientes.vue?vue&type=script&lang=js&"
import style0 from "./saldos_clientes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports